import { faBarcode } from "@fortawesome/free-solid-svg-icons/faBarcode";
import { faCircleCheck } from "@fortawesome/free-solid-svg-icons/faCircleCheck";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons/faCircleExclamation";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons/faQuestionCircle";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons/faTriangleExclamation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IOrcamento } from "app/types/IOrcamento";
import React, { lazy, Suspense, useCallback, useEffect, useRef, useState } from "react";
import globalMU from "../../../globalMU";
import {
    CodigoPergunta,
    DadosFinalizarOrcamento, Inconsistencia,
    LiberarPendencia,
    obterSituacao,
    RespostaPergunta,
    Situacao
} from "../../types/FinalizarOrcamento";
import { todasPerguntasRespondidas } from "./perguntasFinalizacao"; // 493128
import "./calendar.css";
import * as R from 'ramda'
import clsx from "clsx";
import { ResponsaveisServicoAgregado, ResponsaveisServicosAgregados, ServicosAgregadosProps } from "../servicos-agregados-responsaveis/ResponsaveisServicosAgregados";

import { carregarModalLeitorCodigoBarras } from "../pesquisa-produtos/pesquisa-produto/modalLeitorCodigoBarras/carregarModalLeitorCodigoBarras";

// lazy: zxing (~1,3MB) so deve entrar no bundle quando o modal de leitura de codigo de barras for aberto.
// O import() de verdade fica no .js (carregarModalLeitorCodigoBarras) para o webpack conseguir
// gerar um chunk assincrono separado - ver comentario naquele arquivo.
const ModalLeitorCodigoBarras = lazy(() =>
  carregarModalLeitorCodigoBarras().then((m) => ({ default: m.ModalLeitorCodigoBarras }))
);
const estilosBotoes = require('../../estilos/botoes.module.scss').default

const estilosFinalizarOrcamento = require("./finalizar-orcamento.module.scss").default;
const estilosInputs = require('../../estilos/inputs.module.scss').default

export type FinalizarOrcamentoProps = {
    dadosFinalizarOrcamento?: DadosFinalizarOrcamento;
    formLiberarPendencias?: boolean;
    //bloquearInclusaoDeOrcamentoSemCliente?: boolean // 440183
    encerrarOrcamento?: () => void;
    liberarPendencias?: (liberarPendencia: LiberarPendencia) => void;
    definirRespostaInconsistencia?: (codigo: CodigoPergunta, resposta: RespostaPergunta) => void;
    onSituacaoAlterada?: (situacao: Situacao) => void
    orcamento?: IOrcamento
    respostasFinalizacaoOrcamento: { [key: CodigoPergunta]: RespostaPergunta }
    aguardandoProcessamento?: boolean
    processando?: boolean
    exibirComandaFreteLoja?: boolean
    onConfirmarResponsavelExecutor: (agregadosSelecionados: ResponsaveisServicoAgregado[]) => void;
    onLimparResponsavelExecutor: () => void;
    numeroComanda: string
    onNumeroComandaAlterada: (numeroComanda: string) => void
    onConfirmarComanda: (numeroComanda: string) => void
};

export const FinalizarOrcamento = (props: FinalizarOrcamentoProps) => {
    const [abrirModalCodigoBarras, setAbrirModalCodigoBarras] = useState(false)
    const [senha, setSenha] = useState("");
    const [motivo, setMotivo] = useState("");
    const [liberarPendencia, setLiberarPendencia] = useState<boolean>(false)

    const exibirSituacaoApenasOrcamento = () => {
        return (props.dadosFinalizarOrcamento?.Situacoes ?? []).find(s => s.Codigo == 6) != null
    }

    const exibirSituacaoOrcamentoConfirmado = () => {
        const situacao = (props.dadosFinalizarOrcamento?.Situacoes ?? []).find(s => s.Codigo == 1)

        return situacao != null && situacao?.Descricao.toUpperCase() == "ORÇAMENTO CONFIRMADO"
    }

    const exibirSituacaoApenasConfirmado = () => {
        const situacao = (props.dadosFinalizarOrcamento?.Situacoes ?? []).find(s => s.Codigo == 1)

        return situacao != null && situacao?.Descricao.toUpperCase() == "APENAS CONFIRMADO"
    }

    const exibirSituacaoEnviarParaSupervisao = () => {
        return (props.dadosFinalizarOrcamento?.Situacoes ?? []).find(s => s.Codigo == 5) != null
    }

    const situacaoOrcamentoInformada = () => {
        const situacao = props.orcamento?.CodigoSituacaoOrcamentoInformada ?? props.orcamento?.Situacao;
        return (globalMU.isNotNullOrEmpty(situacao) && situacao !== 5) ? situacao : null;
    };

    const orcamentoPossuiAgregadosSemExecutor = () => {
            // mesmo "apenas orcando" tem q escolher porque pode confundir com o "servido adicional/despesas"
        // if (props.orcamento.Situacao == 6) // Apenas Orçamento
        //     return false

        if (props.dadosFinalizarOrcamento?.ServicosAgregadosDados == null || props.dadosFinalizarOrcamento?.ServicosAgregadosDados?.length == 0)
            return false
        const semExecutor = props.dadosFinalizarOrcamento?.ServicosAgregadosDados.find(s => s.ExecutorOid == null ||  s.ExecutorOid <= 7)
        return semExecutor != null
    }

    const orcamentoPossuiPerguntasNaoRespondidas = () => {
        const codigosPerguntasExistentes = ((props.dadosFinalizarOrcamento?.Inconsistencias ?? []).find(tipoInconsistencia => tipoInconsistencia.Tipo == "PERGUNTA")?.Inconsistencias ?? []).map(pergunta => pergunta.Codigo)

        if (codigosPerguntasExistentes.length == 0) {
            return false
        }

        // 493128 - checagem de SUBCONJUNTO: resposta remanescente de pergunta que saiu da tela
        // nao deve esconder o botao Encerrar Orcamento.
        return !todasPerguntasRespondidas(codigosPerguntasExistentes, props.respostasFinalizacaoOrcamento)
    }

    useEffect(() => {
        setLiberarPendencia(senha.length > 0)
    }, [senha])

    useEffect(() => {
        if (globalMU.isNullOrZero(situacaoOrcamentoInformada())) {
            globalMU.showInfoMessage("Selecione a opção do orçamento para poder continuar!")
        }
        //setOpcaoDoOrcamentoSelecionado(props.orcamento.Situacao === 6 || props.orcamento.Situacao === 1)
    }, [props.orcamento?.Situacao])



    const campoComandaFreteLoja =  
        props.exibirComandaFreteLoja && props?.orcamento?.Situacao == 1 && (
                        <div className="_flex _my-2"
                            id="FinalizarOrcamento_CampoComandaFreteLoja"
                        >
                            <label className="_font-normal _mb-0 _mr-3">Comanda</label>
                            <input
                                maxLength={12}
                                className={clsx("_w-[200px]", estilosInputs.inputPadrao)}
                                type="text"
                                id="FinalizarOrcamento_InputComandaFreteLoja"
                                value={(props.numeroComanda) ?? ""}
                                disabled={props?.processando}
                                onBlur={(e) => {
                                    const valorComanda = e.target.value;
                                    if (valorComanda != "" && valorComanda.length <= 12) {
                                        const zerosParaAdicionar = 12 - valorComanda.length;
                                        const comandaComZeros = '0'.repeat(zerosParaAdicionar) + valorComanda;
                                        props.onConfirmarComanda(comandaComZeros)
                                    }
                                }}
                                onKeyDown={(e) => {
                                    if (R.includes(e.code, ["Backspace"]) && e.currentTarget.selectionStart == 12 && e.currentTarget.selectionEnd == 12) {
                                        props.onNumeroComandaAlterada("")
                                    }
                                }}
                                onChange={(event) => {
                                    const valorNumerico = event.target.value.replace(/\D/g, '');
                                    props.onNumeroComandaAlterada(valorNumerico);
                                }}
                            />

                            <FontAwesomeIcon
                                className="_m-1 _mb-0 _text-2xl"
                                color="#3c8ac9"
                                icon={faBarcode}
                                cursor={"pointer"}
                                onClick={() => {
                                  setAbrirModalCodigoBarras(true)}}
                                title={"É Preciso uma câmera com permissão para a funcionalidade de escanear"}
                            />
                        </div>
        );

    const selecaoFuncionarioResponsavelExecucaoServicoAgregado = () => {
        return (
            <>
                {(props.dadosFinalizarOrcamento?.ExibirSelecaoFuncionarioResponsavelExecucaoServicoAgregado 
                || props.dadosFinalizarOrcamento?.ExibirTaxaIssServicoAgregado)
                //&& (props?.orcamento.Situacao == 1  || props?.orcamento.Situacao == 6) // 447380
                && (
                    <div className="_flex _my-2"
                        id="FinalizarOrcamento_ServicosAgregados_ResponsavelExecucao"
                    >
                        <ResponsaveisServicosAgregados 
                            dados={props.dadosFinalizarOrcamento?.ServicosAgregadosDados} 
                            listaExecutores={props.dadosFinalizarOrcamento?.ListaExecutores} 
                            ExibirSelecaoFuncionarioResponsavelExecucaoServicoAgregado={props.dadosFinalizarOrcamento?.ExibirSelecaoFuncionarioResponsavelExecucaoServicoAgregado}
                            ExibirTaxaIssServicoAgregado={props.dadosFinalizarOrcamento?.ExibirTaxaIssServicoAgregado}
                            SomenteLeitura={props.orcamento?.SomenteLeitura}
                            processando={props.aguardandoProcessamento}
                            onConfirmar={props.onConfirmarResponsavelExecutor} 
                            onLimpar={props.onLimparResponsavelExecutor} />
                    </div>
                )}
            </>
        );
    };

    const RadioButtonFinalizarOrcamento = ({ id, value, checked, onClick, label }) => (
        <label htmlFor={id} style={{ cursor: 'pointer', fontWeight: 'unset' }}>
            <input
                type="radio"
                value={(value) ?? ""}
                checked={checked ?? false}
                disabled={props?.processando}
                name={id}
                id={id}
                key={id}
                onChange={onClick}
            />
            {label}
        </label>
    );

    const handleApenasOrcamentoClick = () => {
        props.onNumeroComandaAlterada("");
        props.onSituacaoAlterada(obterSituacao({ descricao: "Apenas Orçamento" }));
    };
    
    const handleApenasConfirmadoClick = () => {
        props.onSituacaoAlterada(obterSituacao({ descricao: "Apenas Confirmado" }));
    };
    
    const handleEnviarParaSupervisaoClick = () => {
        props.onSituacaoAlterada(obterSituacao({ descricao: "Enviar para Supervisão" }));
    };
    
    const handleOrcamentoConfirmadoClick = () => {
        props.onSituacaoAlterada(obterSituacao({ descricao: "Orçamento Confirmado" }));
    };

    const opcoesDoOrcamento = () => (
        <div className={estilosFinalizarOrcamento.tabelaFinalizarOrcamento} id="FinalizarOrcamento_opcoesDoOrcamento_tabela">
            <div className={estilosFinalizarOrcamento.tableCellHeader}>
                Opções do Orçamento
            </div>
    
            <div className={estilosFinalizarOrcamento.tableCellBody} style={{ paddingBottom: "0.75em" }} id="FinalizarOrcamento_opcoesDoOrcamento_corpotabela">
                {exibirSituacaoApenasOrcamento() && (
                    <RadioButtonFinalizarOrcamento
                        id="FinalizarOrcamento_GrupoOpcaoOrcamento_ApenasOrcando"
                        value="6"
                        checked={props?.orcamento?.Situacao === 6}
                        onClick={handleApenasOrcamentoClick}
                        label="Apenas Orçamento"
                    />
                )}
    
                {exibirSituacaoApenasConfirmado() && (
                    <RadioButtonFinalizarOrcamento
                        id="FinalizarOrcamento_GrupoOpcaoOrcamento_ApenasConfirmado"
                        value=""
                        checked={false}
                        onClick={handleApenasConfirmadoClick}
                        label="Apenas Confirmado"
                    />
                )}
    
                {exibirSituacaoEnviarParaSupervisao() && (
                    <RadioButtonFinalizarOrcamento
                        id="FinalizarOrcamento_GrupoOpcaoOrcamento_EnviarparaSupervisao"
                        value="5"
                        checked={false}
                        onClick={handleEnviarParaSupervisaoClick}
                        label="Enviar para Supervisão"
                    />
                )}
    
                {exibirSituacaoOrcamentoConfirmado() && (
                    <RadioButtonFinalizarOrcamento
                        id="FinalizarOrcamento_GrupoOpcaoOrcamento_OrcamentoConfirmado"
                        value="1"
                        checked={props?.orcamento?.Situacao === 1}
                        onClick={handleOrcamentoConfirmadoClick}
                        label="Orçamento Confirmado"
                    />
                )}
            </div>
        </div>
    );
    
    const iconeAlerta = <FontAwesomeIcon
        id="FinalizarOrcamento_Inconsistencias_IconeAlerta"
        icon={faTriangleExclamation}
        color={"#fc0"}
        fontSize={"2em"}
    />

    const iconeErro = <FontAwesomeIcon
        id="FinalizarOrcamento_Inconsistencias_IconeErro"
        icon={faTimesCircle}
        color={"#f00"}
        fontSize={"2em"}
    />

    const iconePendencia = <FontAwesomeIcon
        id="FinalizarOrcamento_Inconsistencias_IconePendencia"
        icon={faCircleExclamation}
        color={"#fc0"}
        fontSize={"2em"}
    />

    const iconeOutro = <FontAwesomeIcon
        id="FinalizarOrcamento_Inconsistencias_IconeAOutros"
        icon={faQuestionCircle}
        fontSize={"2em"}
    />
    const inconsistencias = () => {
        const obterIcone = (tipoInconsistencia: DadosFinalizarOrcamento["Inconsistencias"][0]) => {
            const tipo = tipoInconsistencia.Tipo
            return tipo == "ADVERTENCIA" || tipo == "ALERTA" ? iconeAlerta :
                tipo == "ERRO" ? iconeErro :
                    tipo == "PENDENCIA" ? iconePendencia : iconeOutro
        }

        const obterEstiloMensagem = (tipoInconsistencia: DadosFinalizarOrcamento["Inconsistencias"][0]) => {
            const tipo = tipoInconsistencia.Tipo

            return tipo == "ERRO" ? { color: "#f00" } :
                R.includes(tipo, ["ADVERTENCIA", "ALERTA", "PENDENCIA"]) ? { color: "rgb(255, 204, 0)" } :
                    {}
        }

        const obterTitulo = (tipoInconsistencia: DadosFinalizarOrcamento["Inconsistencias"][0]) => {
            return <h2 style={obterEstiloMensagem(tipoInconsistencia)} className={estilosFinalizarOrcamento.titulo}
                id="FinalizarOrcamento_Inconsistencias_Titulo">
                {`${tipoInconsistencia.DescricaoTipo}`}
            </h2>
        }

        const obterTabela_ADVERTENCIA_ALERTA_ERRO = (tipoInconsistencia: DadosFinalizarOrcamento["Inconsistencias"][0]) => {
            return <div className={estilosFinalizarOrcamento.tabelaFinalizarOrcamento}
                id="FinalizarOrcamento_Inconsistencias_TabelaADVERTENCIA_ALERTA_ERRO">
                <div className={estilosFinalizarOrcamento.tableCellHeader}>
                    Descrição
                </div>
                {tipoInconsistencia.Inconsistencias.map((inconsistencia, index) => (
                    <div
						key={`${inconsistencia.Codigo}_${index}`}
                        className={estilosFinalizarOrcamento.tableCellBody}
                        id="FinalizarOrcamento_Inconsistencias_Tabela_dados"
                    >
                        <div dangerouslySetInnerHTML={{ __html: `${inconsistencia.MensagemUsuario}` }} />
                    </div>
                ))}
            </div>
        }

        const obterTabela_PERGUNTA = (tipoInconsistencia: DadosFinalizarOrcamento["Inconsistencias"][0]) => {
            return(
                <table className={`_table _w-full _border-collapse ${estilosFinalizarOrcamento.tabelaFinalizarOrcamento}`}
                    id="FinalizarOrcamento_Inconsistencias_TabelaPergunta">
                    <thead className="_table-header-group">
                        <tr className="_table-row">
                            <th
                                className={`_table-cell ${estilosFinalizarOrcamento.tableCellHeader}`}
                            >
                                Pergunta
                            </th>
                            <th
                                className={`_table-cell ${estilosFinalizarOrcamento.tableCellHeader}`}
                                style={{ width: "150px" }}
                            >
                                Resposta
                            </th>
                        </tr>
                    </thead>
                    
                    <tbody className="_table-row-group">
                        {tipoInconsistencia.Inconsistencias.map((pergunta, index) => (
                            <tr className="_table-row" 
                                key={`${index}_${pergunta.Codigo}`}
                                id={`FinalizarOrcamento_Inconsistencias_TabelaPergunta_Dados_${index}_${pergunta.Codigo}`}>
                                <td
                                    className={`_table-cell ${estilosFinalizarOrcamento.tableCellBody}`}
                                    key={`Pergunta_Descricao_${index}_${pergunta.Codigo}`}
                                    id={`FinalizarOrcamento_Inconsistencias_TabelaPergunta_Dados_Pergunta_${pergunta.Codigo}`}
                                >
                                    <div dangerouslySetInnerHTML={{ __html: pergunta.MensagemUsuario }}
                                        id={`FinalizarOrcamento_Inconsistencias_Pergunta_${pergunta.Codigo}`}
                                        key={`FinalizarOrcamento_Inconsistencias_Pergunta_${pergunta.Codigo}`}
                                    ></div>
                                </td>
                                <td
                                    className={`_table-cell ${estilosFinalizarOrcamento.tableCellBody}`}
                                    key={`Pergunta_Opcao_${index}_${pergunta.Codigo}`}
                                    id={`FinalizarOrcamento_Inconsistencias_TabelaPergunta_Dados_Pergunta_${index}_${pergunta.Codigo}`}
                                >
                                    <label htmlFor={`FinalizarOrcamento_Inconsistencias_TabelaPergunta_Dados_InputPergunta_${pergunta.Codigo}_Sim`}  
                                        style={{cursor:'pointer', fontWeight: 'unset'}} 
                                        key={`LabelPergunta_${index}_${pergunta.Codigo}`}
                                        id={`FinalizarOrcamento_Inconsistencias_TabelaPergunta_Dados_LabelPergunta_${pergunta.Codigo}`}  
                                    >
                                        <input
                                            name={pergunta.Codigo}
                                            type="radio"
                                            value="1"
                                            disabled={props?.processando}
                                            //id="FinalizarOrcamento_Sim"
                                            id={`FinalizarOrcamento_Inconsistencias_TabelaPergunta_Dados_InputPergunta_${pergunta.Codigo}_Sim`}  
                                            key={`InputPergunta_Sim_${index}_${pergunta.Codigo}`}
                                            
                                            checked={(pergunta.Codigo in props.respostasFinalizacaoOrcamento) && props.respostasFinalizacaoOrcamento[pergunta.Codigo] === true}
                                            className={
                                                estilosFinalizarOrcamento.imputRadioButton
                                            }
                                            onChange={() => {
                                                props.definirRespostaInconsistencia(pergunta.Codigo, true)
                                            }}
                                        />
                                        Sim
                                    </label>
                                    <label 
                                        htmlFor={`FinalizarOrcamento_Inconsistencias_TabelaPergunta_Dados_InputPergunta_${pergunta.Codigo}_Nao`} 
                                        style={{cursor:'pointer', fontWeight: 'unset'}} >
                                        <input
                                            name={pergunta.Codigo}
                                            type="radio"
                                            value="2"
                                            disabled={props?.processando}
                                            //id="FinalizarOrcamento_Nao"
                                            id={`FinalizarOrcamento_Inconsistencias_TabelaPergunta_Dados_InputPergunta_${pergunta.Codigo}_Nao`}  
                                            key={`InputPergunta_Nao_${index}_${pergunta.Codigo}`}
                                            checked={(pergunta.Codigo in props.respostasFinalizacaoOrcamento) &&  props.respostasFinalizacaoOrcamento[pergunta.Codigo] === false}
                                            className={
                                                estilosFinalizarOrcamento.imputRadioButton
                                            }
                                            onChange={() => props.definirRespostaInconsistencia(pergunta.Codigo, false)}
                                        />
                                        Não
                                    </label>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            );
        }

        const TabelaPendencia = ({ inconsistencias }) => (
            <div className={`_table _w-full _border-collapse ${estilosFinalizarOrcamento.tabelaFinalizarOrcamento}`} id="FinalizarOrcamento_Inconsistencias_TabelaPendencia">
                <div className="_table-header-group">
                    <div className="_table-row">
                        <div className={`_table-cell ${estilosFinalizarOrcamento.tableCellHeader}`}>Módulo</div>
                        <div className={`_table-cell ${estilosFinalizarOrcamento.tableCellHeader}`}>Descrição</div>
                        <div className={`_table-cell ${estilosFinalizarOrcamento.tableCellHeader}`}>Status</div>
                    </div>
                </div>
                <div className="_table-row-group">
                    {inconsistencias.map((inconsistencia, index) => (
                        <div className="_table-row" 
							id={`FinalizarOrcamento_DivInconsistencias_${inconsistencia.Modulo}_${index}`}
							key={`${inconsistencia.Modulo}_${index}`}
						>
                            <div style={{ boxShadow: "4px 0 #fc0 inset" }} className={`_table-cell ${estilosFinalizarOrcamento.tableCellBody}`}>{inconsistencia.Modulo}</div>
                            <div className={`_table-cell ${estilosFinalizarOrcamento.tableCellBody}`}>{inconsistencia.MensagemUsuario}</div>
                            <div className={`_table-cell ${estilosFinalizarOrcamento.tableCellBody}`}>
                                {inconsistencia.Autorizado ? "Liberada" : "Aguardando Liberação"}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
        

        const obterTabela_PENDENCIA = (tipoInconsistencia) => {
            return <TabelaPendencia inconsistencias={tipoInconsistencia.Inconsistencias} />;
        };
        


        return <>
            {(props.dadosFinalizarOrcamento?.Inconsistencias ?? []).map((tipoInconsistencia) => (
                <div key={tipoInconsistencia.Tipo}>

                    {obterIcone(tipoInconsistencia)}

                    {obterTitulo(tipoInconsistencia)}


                    {R.includes(tipoInconsistencia.Tipo, ["ADVERTENCIA", "ALERTA", "ERRO"]) && obterTabela_ADVERTENCIA_ALERTA_ERRO(tipoInconsistencia)}

                    {tipoInconsistencia.Tipo == "PERGUNTA" && obterTabela_PERGUNTA(tipoInconsistencia)}

                    {tipoInconsistencia.Tipo == "PENDENCIA" && obterTabela_PENDENCIA(tipoInconsistencia)}


                </div>
            )
            )}
        </>
    }


    const ausenciaInconsistencias = <div className="_flex _flex-row">
        <FontAwesomeIcon
            icon={faCircleCheck}
            id="FinalizarOrcamento_AusenciaInconsistencias"
            fontSize={"2em"}
            color={"#11aa99"}
            style={{ marginRight: "5px" }}
        />
        Não existem inconsistências no orçamento
    </div>

    const liberacaoPendenciaOrcamento = <form className={estilosFinalizarOrcamento.liberarPendencias}
        onSubmit={() => {
            setSenha("")
            props.liberarPendencias({
                senhaLiberacaoPendencia: senha,
                motivoLiberacaoPendencia: motivo,
            })
        }}>
        <div className={estilosFinalizarOrcamento.separador} />
        <div>
            <label>
                Senha:
                <p className={estilosFinalizarOrcamento.obrigatorio}>*</p>
            </label>
            <input
                autoFocus
                type="password"
                id="FinalizarOrcamento_SenhaLiberacaoPendencia"
                disabled={props?.processando}
                value={(senha) ?? ""}
                autoComplete="off"
                aria-autocomplete="none"
                list="autocompleteOff" // para naos mostrar dados digitados anteriormente
                onChange={(e) => setSenha(e.target.value)}
            />
            <button
                disabled={(!liberarPendencia && senha.length <= 0 ) || props?.processando}
                className={estilosFinalizarOrcamento.buttonFinalizarOrcamento}
                id="FinalizarOrcamento_BotaoLiberacaoPendencia"
                style={{ marginLeft: "10px", marginBottom: "5px" }}
                type="submit"

            >
                Liberar Pendências
            </button>
        </div>

        {props.dadosFinalizarOrcamento
            ?.ObrigatorioInformarMotivoLiberacaoPendencias && (
                <div>
                    <label>Motivo</label>
                    <textarea
                        value={(motivo) ?? ""}
                        id="FinalizarOrcamento_MotivoLiberacaoPendencia"
                        disabled={props?.processando}
                        onChange={(e) => setMotivo(e.target.value)}
                    ></textarea>
                </div>
            )}
    </form>


    const botaoEncerrarOrcamento = 
        <button
            className={clsx('no-global-button', estilosBotoes.botaoPrimario)}
            style={{ width: "200px", marginTop: "20px" }}
            id="FinalizarOrcamento_botaoEncerrarOrcamento"
            onClick={() => {
                props.encerrarOrcamento()
            }}
            disabled={senha.length > 0
                        || props?.processando   
                        || (props.exibirComandaFreteLoja && props?.orcamento?.Situacao == 1 && (props?.orcamento?.NumeroComanda ?? "").length < 5) 
                        //|| props?.dadosFinalizarOrcamento?.ExibirSelecaoFuncionarioResponsavelExecucaoServicoAgregado
                    }
        >
            Encerrar Orçamento
        </button>



    const exibirInconsistencias = () => (
        !globalMU.isNullOrZero(situacaoOrcamentoInformada()) &&
        props.dadosFinalizarOrcamento?.Inconsistencias?.length > 0 &&
        inconsistencias()
    );
    
    const exibirAusenciaInconsistencias = () => (
        !globalMU.isNullOrZero(situacaoOrcamentoInformada()) &&
        (props.dadosFinalizarOrcamento?.Inconsistencias?.length ?? 0) === 0 &&
        ausenciaInconsistencias
    );
    
    const exibirLiberacaoPendenciaOrcamento = () => (
        !globalMU.isNullOrZero(situacaoOrcamentoInformada()) &&
        !props.dadosFinalizarOrcamento?.PossuiErros &&
        props.dadosFinalizarOrcamento?.PossuiPendencias &&
        liberacaoPendenciaOrcamento
    );
    /*
    const exibirBotaoEncerrarOrcamento = () => (

        (props.dadosFinalizarOrcamento?.Situacao != undefined && props.dadosFinalizarOrcamento?.Situacao != null) &&
        !props.dadosFinalizarOrcamento?.PossuiErros &&
        !props.dadosFinalizarOrcamento?.CalendarioCapacidadeCarga &&
        !globalMU.isNullOrZero(situacaoOrcamentoInformada()) &&
        !orcamentoPossuiPerguntasNaoRespondidas() &&
        !orcamentoPossuiAgregadosSemExecutor() &&
        !props.processando


        && botaoEncerrarOrcamento
     
        );
    */
   const exibirBotaoEncerrarOrcamento = () => {
    /*
    (props.dadosFinalizarOrcamento?.Situacao != undefined && props.dadosFinalizarOrcamento?.Situacao != null) &&
        !props.dadosFinalizarOrcamento?.PossuiErros &&
        !props.dadosFinalizarOrcamento?.CalendarioCapacidadeCarga &&
        !globalMU.isNullOrZero(situacaoOrcamentoInformada()) &&
        !orcamentoPossuiPerguntasNaoRespondidas() &&
        !orcamentoPossuiAgregadosSemExecutor() &&
        !props.processando


        && botaoEncerrarOrcamento
        */
    
        // Extrai cada condição em variáveis nomeadas - para faciliar DEBUGAR
        let podeFinalizar = true
        podeFinalizar = podeFinalizar &&  !props.processando;
        podeFinalizar = podeFinalizar &&    props.dadosFinalizarOrcamento?.Situacao != null;
        podeFinalizar = podeFinalizar &&  !props.dadosFinalizarOrcamento?.PossuiErros;
        podeFinalizar = podeFinalizar &&  !props.dadosFinalizarOrcamento?.CalendarioCapacidadeCarga;
        podeFinalizar = podeFinalizar &&  !globalMU.isNullOrZero(situacaoOrcamentoInformada());
        podeFinalizar = podeFinalizar &&  !orcamentoPossuiPerguntasNaoRespondidas();
        podeFinalizar = podeFinalizar &&  !orcamentoPossuiAgregadosSemExecutor();
        podeFinalizar = podeFinalizar &&  !props.processando;


        return podeFinalizar ? botaoEncerrarOrcamento : null;
    };

    const conteudo = (
        <div className="_flex _flex-col _gap-2" id="FinalizarOrcamento_Conteudo">
            {exibirInconsistencias()}
            {exibirAusenciaInconsistencias()}
            {exibirLiberacaoPendenciaOrcamento()}
            {exibirBotaoEncerrarOrcamento()}
        </div>
    );
        

    return (
        <div className="_flex _flex-col _gap-2">
            {opcoesDoOrcamento()}
            {campoComandaFreteLoja}
            {selecaoFuncionarioResponsavelExecucaoServicoAgregado()}
            {!props.aguardandoProcessamento && conteudo}
            {abrirModalCodigoBarras &&
            <Suspense fallback={null}>
                <ModalLeitorCodigoBarras
                    abrirModal={abrirModalCodigoBarras}
                    onFecharModal={() => setAbrirModalCodigoBarras(false)}
                    onCodigoBarrasLido={(codigoBarras) => {
                        props.onNumeroComandaAlterada(codigoBarras.getText())
                    }}
                />
            </Suspense>
            }
           
        </div>
    );
};
